import React, { Component } from "react";
import "./CarFormConfirm.css";

import store from "../../store";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";
import Grid from "@material-ui/core/Grid";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import CarFormDetail from "../CarFormDetail/CarFormDetail";
import { isMobile } from "react-device-detect";

class CarFormConfirm extends Component {
  constructor(props) {
    super(props);
  }

  handleChange = event => {};

  componentDidMount() {}

  render() {
    return (
      <div>
        <Header />
        <div className="GridConfirm">
          <Grid container spacing={5} xs={12} sm={12}>
            <Grid container spacing={3} xs={12} sm={7}>
              <div className={isMobile ? "ConfirmTextMobile" : "ConfirmText"}>
                <div
                  className={isMobile ? "ConfirmTitleMobile" : "ConfirmTitle"}
                >
                  ¡Felicitaciones!{" "}
                </div>
                <div
                  className={
                    isMobile ? "ConfirmSubTitleMobile" : "ConfirmSubTitle"
                  }
                >
                  La reserva de tu <b>Corolla </b> fue un éxito.
                </div>
                <div
                  className={
                    isMobile ? "ConfirmTextContentMobile" : "ConfirmTextContent"
                  }
                >
                  En breve recibirás un mail con los datos de tu reserva y los
                  pasos a seguir.
                  <br />
                  <br />
                  ¡Muy pronto vas a estar disfrutando tu 0KM, sin vueltas!
                </div>
              </div>
            </Grid>
            <Grid
              container
              spacing={3}
              xs={9}
              sm={4}
              style={{ marginLeft: "20px" }}
            >
              <Grid item xs={12} sm={12}>
                <div
                  className={
                    isMobile
                      ? "CarFormBox CarFormBoxConfirmMobile"
                      : "CarFormBox CarFormBoxConfirm"
                  }
                >
                  {" "}
                  <div
                    className={
                      isMobile ? "CarFormTitleConfirmMobile" : "CarFormTitle2"
                    }
                  >
                    YA RESERVASTE TU:
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      marginTop: "20px"
                    }}
                  >
                    <div
                      style={{
                        width: "40%"
                      }}
                    >
                      <div
                        style={{
                          fontFamily: "ToyotaBold",
                          fontSize: "1.5rem",
                          marginTop: "10px"
                        }}
                      >
                        COROLLA
                      </div>
                      <div
                        style={{
                          fontFamily: "ToyotaRegular",
                          fontSize: "1.2rem"
                        }}
                      >
                        1.8 Se-g Cvt
                      </div>
                    </div>
                    <div
                      className={
                        isMobile ? "FormCarImgDivMobile" : "FormCarImgDiv"
                      }
                    >
                      <img
                        src="/img/cars/corolla-gray-big.png"
                        className="FormCarImg"
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div>
        {isMobile ? null : <Footer />}
      </div>
    );
  }
}

export default CarFormConfirm;
